enum PrintTabOption {
  Omnichannel = 'omnichannel',
  Google = 'google',
  Adswizz = 'adswizz',
  Dooh = 'dooh',
  Search = 'search',
  Social = 'social',
  Simplifi = 'simplifi',
  Gam = 'gam',
}

export default PrintTabOption;
